@if (deliveryWindowResource.hasValue()) {
  <mat-card>
    <mat-card-content>
      <ui-form-date [formControl]="dateControl" [data]="data" (datePickerToggleEvent)="onDatepickerToggleClicked()"></ui-form-date>
    </mat-card-content>
  </mat-card>
}
